import { withInstall } from '../utils'
import _Empty from './Empty'
import './index.scss'

export const Empty = withInstall(_Empty)
export default Empty
